import React, {Component} from 'react';
import Camera from './Camera';

import './styles/App.css';

//import rotateImage from './media/rotate-screen.gif';
import rotateIcon from './media/rotate-icon.png';
import startButton from './media/c200-start-sim-btn.png';
import titleBanner from './media/c200-title-banner.jpg';
import imageBanner from './media/c200-banner.png';

class App extends Component {
  state = {
    isMobile: undefined,
    startSimulator: false,
  };

  handleWindowResize = () => {
    this.setState({isMobile: window.matchMedia("(orientation: portrait)").matches })
  }

  componentWillMount() {
    this.handleWindowResize();
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowResize);
  }

  startSimulator = () => {
    this.setState({startSimulator: true})
  }

  render() {
    const appBackground = this.state.isMobile && this.state.startSimulator ? "black" : "white";
    const landingPage = 
      <div className="App-landing-page">
        <div className="Landing-page-info">
          <img src={titleBanner} height="" alt="Title" />
          <p className="Landing-page-text">
            The EOS C200 Menu Simulator is an interactive training tool to help you 
            familiarize yourself with the camera's Custom Picture and Main Menus.
          </p>
          <p className="Landing-page-text">
            Navigate with a mouse, keyboard arrow keys, or even your fingers (on a 
            touchscreen device) to control the Simulator and master the Cinema EOS 
            menu system before you get to set.
          </p>
          <button onClick={this.startSimulator} className="Landing-page-button">
            <img src={startButton} alt="Start Button" />
          </button>
          <p className="Landing-page-disclaimer">Simulator available in English only</p>
        </div>
        <div className="Landing-page-image">
          <img src={imageBanner} height="" alt="Canon C200 Camera" />
        </div>
      </div>
    const containerToRender = this.state.isMobile === true 
      ? <div style={{color: "black"}}><img src={rotateIcon} height="300px" alt="Rotate Screen"/></div>
      : <div className="App-container">
          <div className="Camera-body-outer">
            <div className="Camera-body-inner">
                <Camera />
            </div>
            <div className="Camera-body-divider"></div>
          </div>
        </div>
    return (
      <div className="App" style={{backgroundColor: appBackground}}>
        {this.state.startSimulator ? containerToRender : landingPage}
      </div>
    );
  }
  
}

export default App;
